
import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';

function AdminSocialLinks() {
  const [facebookLink, setFacebookLink] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [tripadvisorLink, setTripadvisorLink] = useState(''); // New state for TripAdvisor
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchLinks = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, "siteSettings", "socialLinks");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setFacebookLink(data.facebook || '');
          setInstagramLink(data.instagram || '');
          setWhatsappLink(data.whatsapp || '');
          setTripadvisorLink(data.tripadvisor || ''); // Set TripAdvisor link
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching social links:", error);
        setMessage("Error al cargar los enlaces.");
      }
      setLoading(false);
    };

    fetchLinks();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await setDoc(doc(db, "siteSettings", "socialLinks"), {
        facebook: facebookLink,
        instagram: instagramLink,
        whatsapp: whatsappLink,
        tripadvisor: tripadvisorLink, // Save TripAdvisor link
      });
      setMessage("Enlaces guardados exitosamente!");
    } catch (error) {
      console.error("Error saving social links:", error);
      setMessage("Error al guardar los enlaces.");
    }
    setLoading(false);
  };

  return (
    <div className="admin-content">
      <h3>Gestionar Enlaces de Redes Sociales y WhatsApp</h3>
      {loading && <p>Cargando enlaces...</p>}
      {message && <p className="admin-message">{message}</p>}
      <form onSubmit={handleSave} className="admin-form">
        <div className="form-group">
          <label htmlFor="facebookLink">Enlace de Facebook:</label>
          <input
            type="text"
            id="facebookLink"
            value={facebookLink}
            onChange={(e) => setFacebookLink(e.target.value)}
            placeholder="https://www.facebook.com/tuusuario"
          />
        </div>
        <div className="form-group">
          <label htmlFor="instagramLink">Enlace de Instagram:</label>
          <input
            type="text"
            id="instagramLink"
            value={instagramLink}
            onChange={(e) => setInstagramLink(e.target.value)}
            placeholder="https://www.instagram.com/tuusuario"
          />
        </div>
        <div className="form-group">
          <label htmlFor="whatsappLink">Enlace de WhatsApp:</label>
          <input
            type="text"
            id="whatsappLink"
            value={whatsappLink}
            onChange={(e) => setWhatsappLink(e.target.value)}
            placeholder="https://wa.me/tunumero"
          />
        </div>
        <div className="form-group">
          <label htmlFor="tripadvisorLink">Enlace de TripAdvisor:</label>
          <input
            type="text"
            id="tripadvisorLink"
            value={tripadvisorLink}
            onChange={(e) => setTripadvisorLink(e.target.value)}
            placeholder="https://www.tripadvisor.com/tuperfil"
          />
        </div>
        <button type="submit" disabled={loading}>Guardar Enlaces</button>
      </form>
    </div>
  );
}

export default AdminSocialLinks;
